export const baseURL = (slug) => {
  return `https://www.thecocktaildb.com/api/json/v1/1${slug}`;
};
